/* 캠퍼스 전환 칩 — 사이드바 머리 · 휴대폰 머리.  (docs/campus/IMPLEMENT.md §2-4)

   - 고를 캠퍼스가 둘 이상인 사람(지금은 원장, 개원 뒤에는 겸임 직원)에게만 버튼으로 보입니다.
   - 한 캠퍼스 직원은 잠긴 배지(어느 캠퍼스 화면인지)만, 학생·학부모에게는 아무것도 보이지 않습니다.
   - 이름은 시스템 표시명('본관'·'검단관') — 교직원 화면 전용입니다. 학생·학부모·공개 화면에는 쓰지 않습니다(§0-5).
   - 준비 중 캠퍼스는 원장에게만 보이고 '준비 중' 표시가 붙습니다. */

import React from 'react';
import { useData } from '../contexts/DataContext';

const STAFF = ['admin', 'admin_assistant', 'lecturer', 'ta'];

export default function CampusSwitcher({ compact = false }) {
    const { currentUser, selectableCampuses = [], activeCampusId, setActiveCampusId } = useData() || {};
    if (!currentUser || !STAFF.includes(currentUser.role) || selectableCampuses.length === 0) return null;

    if (selectableCampuses.length === 1) {
        // 한 캠퍼스뿐인데 그게 목동이면(지금 모든 직원) 표시하지 않습니다 — 화면이 예전과 같게.
        if (selectableCampuses[0].id === 'mokdong') return null;
        return (
            <span className="inline-flex items-center px-2.5 py-1 rounded-lg text-xs font-black bg-indigo-50 text-indigo-700 border border-indigo-100">
                {selectableCampuses[0].systemLabel}
            </span>
        );
    }

    const options = [...selectableCampuses.map(c => ({ id: c.id, label: c.systemLabel, preparing: c.status !== 'active' })), { id: 'all', label: '전체' }];
    return (
        <div role="radiogroup" aria-label="캠퍼스 선택"
             className={`inline-flex rounded-xl bg-gray-100 p-0.5 ${compact ? 'text-[11px]' : 'text-xs'} font-black`}>
            {options.map(o => {
                const on = activeCampusId === o.id;
                return (
                    <button key={o.id} type="button" role="radio" aria-checked={on}
                            onClick={() => setActiveCampusId(o.id)}
                            title={o.preparing ? '준비 중 — 원장에게만 보입니다' : undefined}
                            className={`px-2.5 py-1 rounded-lg transition whitespace-nowrap ${on ? 'bg-white text-indigo-700 shadow-sm' : 'text-gray-500 hover:text-gray-700'}`}>
                        {o.label}{o.preparing && <span className="ml-1 text-[10px] font-bold text-amber-600">준비</span>}
                    </button>
                );
            })}
        </div>
    );
}
